import React, { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Person } from '@mui/icons-material';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import ReviewWrapper from '../ReviewWrapper';
import ReviewText from '../ReviewText';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';
import { useTranslation } from 'react-i18next';

interface Props extends IReviewNewProps {}

const GolocalReview: FC<Props> = ({
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { username, text, rating, header } = reviewEntry.review;
  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      {username && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: theme.palette.text.secondary,
          }}
        >
          <Person fontSize="small" />
          <Typography
            variant="body1"
            sx={{ ml: theme.spacing(1) }}
          >
            {username}
          </Typography>
        </Box>
      )}
      {header && (
        <Typography
          variant="body1"
          sx={{
            mt: theme.spacing(1),
            fontWeight: 700,
          }}
        >
          {header}
        </Typography>
      )}
      <ReviewText text={text} />
    </ReviewWrapper>
  );
};

export default GolocalReview;
